import { tv } from 'tailwind-variants';

export const styles = tv({
  slots: {
    base: 'container'
  }
});
